import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDotsVertical20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDotsVertical20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m1.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDotsVertical20);
